module.exports = __webpack_public_path__ + "static/cloak_of_protection-7d79cc7947a4d9be896f1c548ce0a465.jpeg";